import React from 'react';

import { FormField, Heading, Label } from '@zillow/constellation-10';

import type { Section } from '../../../../../models';
import YesAndNoExpansion from '../../../../Widgets/YesAndNoExpansion';
import CurrencyInput from '../../../../Widgets/CurrencyInput';

type Props = {
  section: Section;
  annualCostsField: string;
  knowAnnualCostsUtilityProviderField: string;
  setSectionValues: (keyValuePairs: object) => void;
  utilityName: string;
};

export default function UtilitiesOwnRentalProperty({
  section,
  setSectionValues,
  utilityName,
  annualCostsField,
  knowAnnualCostsUtilityProviderField,
}: Props): JSX.Element {
  function onAnnualCostsChange(event): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [annualCostsField]: value,
    });
  }

  function onNoKnowAnnualCostsUtilityProviderField(): void {
    setSectionValues({
      [knowAnnualCostsUtilityProviderField]: false,
    });
  }

  function onYesKnowAnnualCostsUtilityProviderField(): void {
    setSectionValues({
      [knowAnnualCostsUtilityProviderField]: true,
    });
  }

  return (
    <>
      <Heading level={3} textStyle="responsive.heading-xs" css={{ marginBottom: 'layout.tight' }}>
        {utilityName}
      </Heading>
      <FormField
        required
        label={
          <Label>{`Do you know the annual costs of ${utilityName.toLowerCase()} from the utility provider that provided the primary service during the
        previous 12 months?`}</Label>
        }
        control={
          <YesAndNoExpansion
            yesActive={section.getFieldValue(knowAnnualCostsUtilityProviderField)}
            yesHandler={onYesKnowAnnualCostsUtilityProviderField}
            noHandler={onNoKnowAnnualCostsUtilityProviderField}
          >
            <FormField
              required
              label={<Label>{`What are the annual costs?`}</Label>}
              control={<CurrencyInput value={section.getFieldValue(annualCostsField)} onChange={onAnnualCostsChange} />}
            />
          </YesAndNoExpansion>
        }
      />
    </>
  );
}
